import { CompanyManagerDashboard } from '@/domain/usecases/dashboard/company-manager/company-manager-dashboard'
import { queryClient } from '@/infra/http'
import { importRemote } from '@/main/routes/helpers/loaders'

/**
 * Loads company manager dashboard data
 * Simple loader that fetches dashboard list for company managers
 */
export async function loadCompanyManagerDashboard() {
  const remote = await importRemote<CompanyManagerDashboard>(
    'makeRemoteCompanyManagerDashboard',
    queryClient
  )
  return remote.getDashboardList()
}
